module.exports = __webpack_public_path__ + "img/LUB00380.a4ff730f.svg";